"use client"

import { Check, Languages } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Button } from "@/ui/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/ui/components/ui/dropdown-menu"
import { FALLBACK_LOCALE, SUPPORTED_LOCALES } from "@/shared/lib/i18n/resources.ts"

export function LanguageToggle() {
  const { t, i18n } = useTranslation()

  const active =
    SUPPORTED_LOCALES.find((l) => l.code === i18n.resolvedLanguage) ??
    SUPPORTED_LOCALES.find((l) => l.code === FALLBACK_LOCALE)!

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-9 gap-2 px-2">
          <Languages className="h-4 w-4 shrink-0" />
          <span aria-hidden="true" className="text-base leading-none">
            {active.flag}
          </span>
          {/* The name drops on narrow viewports, never the flag: where regional
              indicators render as plain letters, a lone flag reads as "US". */}
          <span className="hidden text-sm font-medium lg:inline">{active.label}</span>
          <span className="sr-only">{t("language.toggle")}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-48">
        {SUPPORTED_LOCALES.map((locale) => (
          <DropdownMenuItem
            key={locale.code}
            onClick={() => i18n.changeLanguage(locale.code)}
            className="gap-2"
          >
            <span aria-hidden="true" className="text-base leading-none">
              {locale.flag}
            </span>
            <span className="flex-1">{locale.label}</span>
            {locale.code === active.code && <Check className="h-4 w-4 shrink-0" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
